import React, {useEffect, useRef, useState} from "react";
import DivDiagonal from "../../../components/DivDiagonal";
import {Form} from "@unform/web";
import * as Yup from "yup";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import {AiOutlineSearch} from "react-icons/ai";
import CustomButton from "../../../components/Form/Button";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../../utils/date";
import CardManagementSuccess from "../../../components/Report/Disciplina/CardManagementSuccess";
import {getReport} from "../../../services/Disciplina";
import CardManagementFailure from "../../../components/Report/Disciplina/CardManagementFailure";
import TooltipDefault from "../../../components/TooltipDefault";
import {currencyFormat} from "../../../utils/masks";
import {useSelector} from "react-redux";
import InputDate from "../../../components/Form/InputDate";
import {useTranslation} from "react-i18next";
import {TradingWrapper, ContentArea} from "../../Trading/styles";
import {StrategyProductCard} from "../../Strategy/styles";
import {FormWrapper} from "../../../styles/listPageTheme";
import {
    DisciplineCard,
    CardHeaderBarNeutral,
} from "../../../components/Report/Disciplina/styles";
import {
    PageInner,
    DisciplineReportStack,
    DisciplinePageHeader,
    DisciplineWideCardColumn,
    FilterSection,
    FilterTitle,
    FilterRow,
    FilterField,
    FilterActions,
    ObservationsBox,
    StatsGrid,
    GridItem,
    GridItemWide,
    AssessmentBody,
    AssessmentCaption,
    AssessmentScoreRow,
    AssessmentScoreIntro,
    AssessmentScoreNumber,
    AssessmentScoreOutro,
    calcPrimaryButtonStyle,
} from "./styles";

export default function TradingReport() {
    const formRef = useRef(null);
    const [totalDays, setTotalDays] = useState(null);
    const [dataManagementFailure, setDataManagementFailure] = useState({
        qtdeDays: 0
    });
    const { t } = useTranslation();

    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    const [dataManagementSuccess, setDataManagementSuccess] = useState({
        qtdeDays: 0
    });

    const [filter, setFilter] = useState([
        {
            startDate: dateFirstDayCurrent(),
            endDate: dateCurrent(),
        }
    ]);

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter(
                [{
                    startDate: data.startDate,
                    endDate: data.endDate,
                }]
            );

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect( () => {
        getReport({
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
        }).then((data) => {
            if (!data || data === '' || !data.data) {
                return;
            }

            setDataManagementFailure({
                qtdeDraw: parseInt(data.data.dataManagementFailure[0].qtdeDraw),
                qtdeWin: parseInt(data.data.dataManagementFailure[0].qtdeWin),
                qtdeLoss: parseInt(data.data.dataManagementFailure[0].qtdeLoss),
                profitObtained: parseFloat(data.data.dataManagementFailure[0].profitObtained),
                qtdeDays: data.data.dataManagementFailure.qtdeDays
            });

            setDataManagementSuccess({
                qtdeDraw: parseInt(data.data.dataManagementSuccess[0].qtdeDraw),
                qtdeWin: parseInt(data.data.dataManagementSuccess[0].qtdeWin),
                qtdeLoss: parseInt(data.data.dataManagementSuccess[0].qtdeLoss),
                profitObtained: parseFloat(data.data.dataManagementSuccess[0].profitObtained),
                qtdeDays: data.data.dataManagementSuccess.qtdeDays
            });

            setTotalDays(data.data.dataManagementSuccess.qtdeDays + data.data.dataManagementFailure.qtdeDays)
        });
    }, [filter]);

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = calcPrimaryButtonStyle.boxShadow;
    };

    const assessmentNote = dataManagementSuccess.qtdeDays
        ? currencyFormat((dataManagementSuccess.qtdeDays * 100 / totalDays) * 10 / 100)
        : 0;

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <PageInner>
                            <DisciplineReportStack>
                            <DisciplinePageHeader>
                                <h1>
                                    <i className="fa fa-graduation-cap" aria-hidden="true"/>
                                    {' '}{t('discipline_report_title')}
                                </h1>
                            </DisciplinePageHeader>

                            <DisciplineWideCardColumn>
                                <StrategyProductCard>
                                    <FilterSection>
                                        <Form ref={formRef} onSubmit={handleSubmit}>
                                            <FilterTitle>
                                                <i className="fas fa-funnel-dollar" aria-hidden="true"/>
                                                {t('filter')}
                                            </FilterTitle>
                                            <FormWrapper>
                                                <FilterRow>
                                                    <FilterField>
                                                        <InputDate
                                                            name="startDate"
                                                            label={t('filter_start_date')}
                                                            value={firstDayMonth()}
                                                            size={"small"}
                                                        />
                                                    </FilterField>
                                                    <FilterField>
                                                        <InputDate
                                                            name="endDate"
                                                            label={t('filter_end_date')}
                                                            value={new Date()}
                                                            size={"small"}
                                                        />
                                                    </FilterField>
                                                    <FilterActions>
                                                        <CustomButton
                                                            type="submit"
                                                            style={calcPrimaryButtonStyle}
                                                            onMouseEnter={buttonHoverIn}
                                                            onMouseLeave={buttonHoverOut}
                                                            startIcon={<AiOutlineSearch/>}
                                                        >
                                                            {t('filter_btn_submmit')}
                                                        </CustomButton>
                                                    </FilterActions>
                                                </FilterRow>
                                            </FormWrapper>
                                        </Form>
                                    </FilterSection>

                                    <ObservationsBox>
                                        <div className="obs-title">
                                            <i className="fa fa-info-circle" aria-hidden="true"/>
                                            {t('discipline_observations')}
                                        </div>
                                        <div className="obs-text">
                                            <p>{t('discipline_observations_1')}</p>
                                            <p>{t('discipline_observations_2')}</p>
                                            <p>{t('discipline_observations_3')}</p>
                                        </div>
                                    </ObservationsBox>

                                    <StatsGrid>
                                        <GridItem>
                                            <CardManagementSuccess
                                                filter={filter}
                                                data={dataManagementSuccess}
                                            />
                                        </GridItem>
                                        <GridItem>
                                            <CardManagementFailure
                                                filter={filter}
                                                data={dataManagementFailure}
                                            />
                                        </GridItem>
                                        <GridItemWide>
                                            <DisciplineCard>
                                                <CardHeaderBarNeutral>
                                                    <span>{t('discipline_assessment_title')}</span>
                                                    <TooltipDefault
                                                        className="cursor-pointer"
                                                        title={t('discipline_assessment_info')}
                                                    >
                                                        <i className="fa fa-info-circle" aria-hidden="true"/>
                                                    </TooltipDefault>
                                                </CardHeaderBarNeutral>
                                                <AssessmentBody>
                                                    {totalDays ? (
                                                        <>
                                                            <AssessmentCaption>
                                                                {t('discipline_assessment_caption')}
                                                            </AssessmentCaption>
                                                            <AssessmentScoreRow>
                                                                <AssessmentScoreIntro>
                                                                    {t('discipline_assessment_score_intro')}
                                                                </AssessmentScoreIntro>
                                                                <AssessmentScoreNumber>
                                                                    {assessmentNote}
                                                                </AssessmentScoreNumber>
                                                                <AssessmentScoreOutro>
                                                                    {t('discipline_assessment_score_outro')}
                                                                </AssessmentScoreOutro>
                                                            </AssessmentScoreRow>
                                                        </>
                                                    ) : (
                                                        <span className="assessment-muted">{t('alert_not_fount_register')}</span>
                                                    )}
                                                </AssessmentBody>
                                            </DisciplineCard>
                                        </GridItemWide>
                                    </StatsGrid>
                                </StrategyProductCard>
                            </DisciplineWideCardColumn>
                            </DisciplineReportStack>
                        </PageInner>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
